import React from 'react';
import { HStack, Label, Text } from '@medely/ui-kit';
import useDialog from '@mp/hooks/useDialog';
import { PositionsDetailsModal } from '../../../../../components/positionsDetailsModal/PositionsDetailsModal';
import { IPosition } from '@medely/types';

export type PositionsDetailsModalButtonProps = {
  positions: IPosition[];
};

export const PositionsDetailsModalButton = ({ positions }: PositionsDetailsModalButtonProps) => {
  const { open, openDialog, closeDialog } = useDialog();

  return (
    <>
      <HStack
        gap={0.5}
        alignItems="center"
        onClick={() => openDialog()}
        testId="positions-details-modal-button"
      >
        <Label size="m" color="state.teal.secondary">
          Learn more
        </Label>
        <Text size="m">about each position</Text>
      </HStack>
      <PositionsDetailsModal positions={positions} open={open} onClose={closeDialog} />
    </>
  );
};
